import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom
// @mui
import { Collapse } from '@mui/material';
// hooks
import useActiveLink from '../../../hooks/useActiveLink';
//
import NavItem from './NavItem';

// ----------------------------------------------------------------------

NavList.propTypes = {
  data: PropTypes.object,
  depth: PropTypes.number,
  hasChild: PropTypes.bool,
};

export default function NavList({ data, depth, hasChild }) {
  const { pathname } = useLocation();
  const navigate = useNavigate(); // Import useNavigate from react-router-dom

  const { active, isExternalLink } = useActiveLink(data.path);
  const childActive = isAnyChildActive(data.children, pathname);
  const parentActive = active || childActive;

  const [open, setOpen] = useState(true);

  // const handleToggle = (event) => {
  //   event.stopPropagation(); // Prevent event bubbling
  //   setOpen(!open);
  // };

  const handleNavigate = () => {
    if (!isExternalLink) {
      navigate(data.path); // Navigate to the item's path
    }
  };

  return (
    <>
      <NavItem
        item={data}
        depth={depth}
        open={open}
        active={parentActive}
        isExternalLink={isExternalLink}
        onClick={() => {
          handleNavigate();
          // if (hasChild) handleToggle();
        }}
      />

      {hasChild && (
        <Collapse in={open} unmountOnExit>
          <NavSubList data={data.children} depth={depth} />
        </Collapse>
      )}
    </>
  );
}

// ----------------------------------------------------------------------

NavSubList.propTypes = {
  data: PropTypes.array,
  depth: PropTypes.number,
};

function NavSubList({ data, depth }) {
  return (
    <>
      {data.map((list) => (
        <NavList
          key={list.title + list.path}
          data={list}
          depth={depth + 1}
          hasChild={!!list.children}
        />
      ))}
    </>
  );
}

function isAnyChildActive(children, pathname) {
  if (!children) return false;
  return children.some(child => {
    const { active } = useActiveLink(child.path);
    return active || isAnyChildActive(child.children, pathname);
  });
}
